import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface LegalBannerState {
  /** Indica se o banner foi fechado temporariamente nesta sessão */
  isBannerDismissed: boolean
  /** Fecha o banner temporariamente (reaparece no próximo login) */
  dismissBanner: () => void
  /** Reseta o estado do banner (chamado no logout ou quando há novos termos) */
  resetBanner: () => void
}

export const useLegalBannerStore = create<LegalBannerState>()(
  persist(
    (set) => ({
      isBannerDismissed: false,

      dismissBanner: () => {
        set({ isBannerDismissed: true })
      },

      resetBanner: () => {
        set({ isBannerDismissed: false })
      },
    }),
    {
      name: 'legal-banner-storage',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
